/**
 * Flaga admina HotelSpot z dokumentu `users/{uid}` (`profileIsAdmin` w userState).
 * Osobny plik bez Firebase, żeby dało się go testować bez inicjalizacji SDK.
 * `null` = dokument jeszcze nieodczytany; widoki z przekierowaniem na to czekają.
 */
export const readProfileIsAdmin = (data: { isAdmin?: unknown; isHotelspotAdmin?: unknown } | null | undefined): boolean => data?.isAdmin === true || data?.isHotelspotAdmin === true;

/** Stan przy nowym koncie: poprzednia flaga nie dotyczy nowego uid. */
export const profileAdminPatchOnUserChange = (): { profileIsAdmin: null } => ({ profileIsAdmin: null });

/**
 * Stan przy błędzie snapshotu `users/{uid}`: dokument nie przyjdzie, więc flaga
 * musi przestać być `null`, inaczej DeleteOrganization czekałby w nieskończoność
 * (pusta strona). Bez odczytu nie przyznajemy admina.
 */
export const profileAdminPatchOnSnapshotError = (): { isResolved: true; profileIsAdmin: false } => ({
  isResolved: true,
  profileIsAdmin: false,
});
